export const QUERY_KEY_WORKFLOW_DEFINITION = 'workflow-definition'

export enum WorkflowSource {
  Configured = 'configured',
  NonConfigured = 'non_configured',
}

export const WORKFLOW_CONFIG_QUERY_KEYS = {
  all: [QUERY_KEY_WORKFLOW_DEFINITION] as const,
  companiesListFiltered: (source: WorkflowSource, searchQuery?: string) =>
    [
      ...WORKFLOW_CONFIG_QUERY_KEYS.all,
      'companies',
      'filtered',
      source,
      searchQuery || '',
    ] as const,
  workflowByCompany: (companyId: string) =>
    [...WORKFLOW_CONFIG_QUERY_KEYS.all, 'company', companyId] as const,
}

export const MAX_REMINDER_NAME_LENGTH = 255

export const WORKFLOW_QUERY_CONFIG = {
  INITIAL_PAGE_PARAM: 0,
  STALE_TIME: 1 * 60 * 1000,
} as const

export const WORKFLOW_CONFIG_ERROR_CODES = {
  NAME_ALREADY_EXISTS: 'REMINDER_NAME_EXISTS',
  THRESHOLD_ALREADY_EXISTS: 'REMINDER_THRESHOLD_EXISTS',
  INVALID_THRESHOLD: 'INVALID_THRESHOLD',
} as const

export const COMPANY_SORT_BY_NAME = '+name'
